import { CollapsibleSection } from "../sectionShared.js";

export interface AssignedAsset {
  id: string; assignedAt: string;
  asset: { assetTag: string; name: string; category: string; condition: string };
}

export function AssignedAssetsSection({ assets }: { assets: AssignedAsset[] }) {
  return (
    <CollapsibleSection id="assets" title="Assigned Assets">
      {assets.length === 0
        ? <p style={{ fontSize: 13, color: "var(--color-surface-400)", margin: 0 }}>No assets currently assigned.</p>
        : <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead><tr style={{ background: "var(--color-surface-50)", borderBottom: "1px solid var(--color-surface-200)" }}>
                {["Tag","Name","Category","Condition","Issued On"].map(h => (
                  <th key={h} style={{ textAlign: "left", padding: "8px 12px", fontWeight: 600, fontSize: 11, textTransform: "uppercase", letterSpacing: "0.4px", color: "var(--color-surface-500)" }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {assets.map((a, i) => (
                  <tr key={a.id} style={{ borderBottom: i < assets.length - 1 ? "1px solid var(--color-surface-100)" : "none" }}>
                    <td style={{ padding: "8px 12px", fontFamily: "monospace", fontSize: 12 }}>{a.asset.assetTag}</td>
                    <td style={{ padding: "8px 12px", fontWeight: 600 }}>{a.asset.name}</td>
                    <td style={{ padding: "8px 12px" }}>{a.asset.category}</td>
                    <td style={{ padding: "8px 12px" }}>{a.asset.condition}</td>
                    <td style={{ padding: "8px 12px" }}>{new Date(a.assignedAt).toLocaleDateString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      }
    </CollapsibleSection>
  );
}
